import { CURRRENT_VIEW, MODAL_VIEW } from '../../../../components/Movers/MoversShipping/constant';

export default {
  appointment: {
    setupDate: '',
    disconnectDate: '',
  },
  moveServiceInfo: { firstName: '' },
  orderDetailsView: {},
  orderNo: '',
  confirmation: {},
  errorInfo: {
    status: false,
    msg: '',
  },
  suspendInfo: {
    status: false,
    msg: '',
  },
  allPlansDetails: {},
  plans: {},
  planDetails: {},
  comparePlan: {
    planDetails: null,
    errorInfo: {
      status: false,
      msg: '',
    },
  },
  getAvailablePlansError: '',
  getUpdateCustomerPlanError: '',
  estimatedBillSummary: {},
  importantAccountChanges: {},
  agreement: {
    agreementDetails: null,
    errorInfo: {
      status: false,
      msg: '',
    },
  },
  mtn: '',
  cbandJson: null,
  fccContentValue: null,
  fccError: {
    errorValue: false,
    errorMessage: '',
  },
  deviceSetupData: {
    setupType: '',
    moveInDate: '',
    moveOutDate: '',
    selectedSlot: '',
    dateAutoAdjusted: false,
  },
  retrieveEquipmentListSuccess: {},
  errorRetrieveEquipmentList: '',
  appointmentSuccess: {},
  errorAppointment: '',
  updatecartSuccess: {},
  errorUpdateCart: '',
  showSelectDateBanner: false,
  shippingAddressData: {
    selectedShippingAddress: {},
    selectedShippingOption: '',
    currentView: CURRRENT_VIEW.IS_NON_ISPU_OPTION_SELECTED,
    shippingAddressList: [],
    newAddressForm: {},
    showModal: MODAL_VIEW.HIDE_AUTHENTICATION_MODEL,
  },
  updateShippingAPIResponse: {},
  shippingInfoData: {
    shippingOptions: {},
    shippingInfo: {},
    isShippingAvailable: true,
  },
  validateCartCheckoutResponse: {},
  getDefaultShipping: false,
  lvSuspendedMove: false,
};
